// extracted by mini-css-extract-plugin
module.exports = {"card":"GenericCard_card__10ERH","slidein":"GenericCard_slidein__32G7k","cardButton":"GenericCard_cardButton__1kbHF","backButton":"GenericCard_backButton__1ahJP"};